import { useNavigate } from "react-router";
import type { ReactNode } from "react";

interface Props {
  title: string;
  back?: boolean;
  right?: ReactNode;
}

export const TopBar = ({ title, back, right }: Props) => {
  const nav = useNavigate();
  return (
    <div className="topbar">
      {back && (
        <button className="back" onClick={() => nav(-1)} aria-label="back">
          ←
        </button>
      )}
      <h1>{title}</h1>
      <div className="spacer" />
      {right}
    </div>
  );
};
